import { FullReportRepository } from '../../domain/repository';
import { FullReportRepositoryImpl } from '../repository';

export const fullReportProviders = [
  {
    provide: FullReportRepository,
    useExisting: FullReportRepositoryImpl,
  },
];


